export const BLACK = '#323232';
export const RED = '#b74b41';
export const BLUE = '#607bab';
export const SKIN = '#f3e3d3';
export const WHITE = '#ffffff';
export const GREEN = '#82964f';
